import { createFileRoute, Outlet, useNavigate } from '@tanstack/react-router';
import { useEffect } from 'react';

export const Route = createFileRoute('/_authenticated/_layout/settings/')({
  component: Settings,
});

function Settings() {
  const navigate = useNavigate({ from: '/settings' });

  useEffect(() => {
    navigate({ to: '/settings/account' });
  }, []);

  return (
    <div className='flex flex-col h-full'>
      <div className='flex-1 space-y-8 py-4'>
        <Outlet />
      </div>
    </div>
  );
}
